import React, { useState, useEffect ,useRef } from "react";
import apiClient from "../apiClient";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaSpinner } from 'react-icons/fa';

import { useShop } from '../context/ShopContext';
import Sidebar from "./Sidebar";



const Boxentrydesitransfer = () => {
  const location = useLocation();
  const navigate = useNavigate(); // For navigation
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [shopId, setShopId] = useState(null);
  const [tokenString, setToken] = useState(null);
  const [shopName,setshopName] = useState(null);

  const inputRefs = useRef([]);
  const [apiConditionMet, setApiConditionMet] = useState(null); 
    const [shopOptions, setShopOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);  
    const [rsbclData, setRsbclData] = useState(null); 
    const [transactionNo, setTransactionNo] = useState("");
    const [errors, setErrors] = useState({});
    const [transferStocks, setTransferStocks] = useState({});
      
    const [showPreview, setShowPreview] = useState(false);
    const [previewData, setPreviewData] = useState({});
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [boxQuantities, setBoxQuantities] = useState({});
   
  

  
const { userId ,companyId } = useShop();
  
 
const [receiveType, setReceiveType] = useState("");
const [selectedTypeName, setSelectedTypeName] = useState("");
const [invoiceNo, setInvoiceNo] = useState("");
const [shop, setShop] = useState("");
const [partyMaster, setPartyMaster] = useState("");
const [transferTypes, setTransferTypes] = useState([]);
const [shops, setShops] = useState([]);
const [partyMasters, setPartyMasters] = useState([]);
const [selectedProducts, setSelectedProducts] = useState([]);
const [remark, setRemark] = useState(""); 
const [searchedProducts, setSearchedProducts] = useState([]);
const [boxInputs, setBoxInputs] = useState({});
const [totalQuantities, setTotalQuantities] = useState({});
  const [receivedStockQty, setReceivedStockQty] = useState(0);
  const [transferStockQty, setTransferStockQty] = useState(0);







const showToast = (message, type = "error") => {
              toast.dismiss(); 
            
              console.log("Toast Type:", type); 
            
              if (type.toLowerCase() === "error") {
                toast.error(message);
              } else if (type.toLowerCase() === "success") {
                toast.success(message);
              } else {
                console.warn("Invalid toast type:", type);
              }
            };

   


   useEffect(() => {
     const savedShopId = localStorage.getItem("shopId");
     const savedTokenString = localStorage.getItem("tokenString");
     const savedshopName =localStorage.getItem("shopName");
 
 
 
     if (savedShopId && savedTokenString && savedshopName) {
       setShopId(savedShopId);
       setToken(savedTokenString);
       setshopName(savedshopName);
     } else {
       showToast("Please log in first!","error");
       navigate("/signin"); // Redirect to login page if not logged in
     }
   }, [navigate]);




  useEffect(() => {
    if (shopId && tokenString && shopName && shopName) {
      fetchStock();
    }
  }, [shopId, tokenString, shopName,date]);

   // Set default from date to today's date on initial render
   useEffect(() => {
    const today = new Date();
    const isoDate = today.toISOString().split("T")[0]; // Get today's date in yyyy-MM-dd format
    setDate(isoDate); // Set the default date
  }, []);


   useEffect(() => {
      const today = new Date();
      const formattedDate = today
        .toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
        .replace(",", ""); // Remove comma if any
  
      // Convert to ISO 8601 format for <input type="date">
      const isoDate = today.toISOString().split("T")[0]; // yyyy-MM-dd
      setDate(isoDate);
    }, []);
  
  
  
  




    useEffect(() => {
      if (searchQuery.trim()) {
        const filtered = products.filter((product) =>
          product.name.toLowerCase().includes(searchQuery.toLowerCase())
        );
        setFilteredProducts(filtered);
    
        // ✅ Preview Data bhi update karein
        setPreviewData((prevData) => ({
          ...prevData,
          selectedProducts: filtered.filter((product) => selectedProducts.includes(product.id)),
        }));
      } else {
        setFilteredProducts(products);
    
        // ✅ Preview Data me selected products ko retain karein
        setPreviewData((prevData) => ({
          ...prevData,
          selectedProducts: products.filter((product) => selectedProducts.includes(product.id)),
        }));
      }
    }, [searchQuery, products, selectedProducts]); // ✅ selectedProducts ko bhi dependency list me add karein
    



  useEffect(() => {
    const today = new Date();
    const formattedDate = today
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(",", ""); // Remove comma if any

    // Convert to ISO 8601 format for <input type="date">
    const isoDate = today.toISOString().split("T")[0]; // yyyy-MM-dd
    setDate(isoDate);
  }, []);






  const fetchStock = async () => {
    setLoading(true);
    setError(null);
    try {
        const response = await apiClient.post(
            "/Liquor/GetProductDataWithDate",
            {
              shopId,
              typeId: "2",
              stockDate: date || new Date().toISOString().split("T")[0],
            }
        );

        console.log("Editproductdata: ", response);
        const fetchedProducts = response.data.data || [];

        const updatedProducts = fetchedProducts.map((product) => ({
            id: product.id,
            name: product.pName,
            selected: false,
            variants: [
                {
                    volume: product.packing,
                    rate: parseFloat(product.mrp),
                    openingStock: parseFloat(product.openingStock || 0),
                    receivedStock: parseFloat(product.receivedQty || 0),
                    transferStock: "",
                    currentStock: "",
                    isSubmitted: false,
                },
            ],
        }));

      
        setProducts(updatedProducts);
        setFilteredProducts(updatedProducts);

     
        setSearchedProducts(updatedProducts); 

        setApiConditionMet(true); 
    } catch (err) {
        setError("Error fetching stock data");
        console.error("Error fetching stock:", err);
        setApiConditionMet(false); 
    } finally {
        setLoading(false);
    }
};



  






useEffect(() => {
    const fetchTransferTypes = async () => {
      try {
        const response = await apiClient.post(
          '/Liquor/GetTypeMst',
          {shopId , companyId}
        );
        console.log("fetchTransferTypes in edit stock",response)

        const options = response.data?.data?.map((item) => ({
          id: item.id,
          label: item.name,
          type: item.typeName,  // Used for condition checking
          type1:item.type,
        }));
        setTransferTypes(options);
      } catch (err) {
        console.error('Error fetching dropdown options:', err);
        showToast('Failed to load dropdown options.',"error");
      }
    };
    fetchTransferTypes();
  }, []);



  useEffect(() => {
    const fetchPartyMasters = async () => {
      try {
        const response = await apiClient.post(
          '/Liquor/GetPartyMaster',
          { companyId }
        );
        console.log("fetchPartyMasters", response);
  
        const options = response.data?.data?.map((item) => ({
          id: item.id,
          label: item.name,
        }));
        setPartyMasters(options);
      } catch (err) {
        console.error('Error fetching party master options:', err);
        showToast('Failed to load party masters.',"error");
      }
    };
  
    fetchPartyMasters();
  }, []);
  

  useEffect(() => {
    // Function to fetch shop options from the API
    const fetchShopOptions = async () => {
      try {
        const response = await apiClient.post(
          '/Liquor/GetShopMaster',
          { userId ,companyId }
        );
        console.log("fetchShopOptions67:", response)
  
        const options = response.data?.data?.map((item) => ({
          id: item.id,
          label: item.name,
        }));
        console.log("options",options)
        
        // Assuming the API returns an array of shop options
        setShopOptions(options);
        setIsLoading(false); // Set loading to false after data is fetched
      } catch (err) {
        setError('Failed to fetch shop options');
        setIsLoading(false);



      }
    };
  
    fetchShopOptions(); // Call the function to fetch data
  }, []); // Empty dependency array means this runs only once when the component mounts


 



  const handleCheckboxChange = (productId) => {
    setSelectedProducts((prevSelected) => {
      if (prevSelected.includes(productId)) {
        return prevSelected.filter(id => id !== productId);
      } else {
        return [...prevSelected, productId];
      }
    });
  };

  
  



  // const handletransferStockChange = (productIndex, variantIndex, value) => {
  //   if (!selectedProducts.includes(filteredProducts[productIndex].id)) return;
  
   
  //   if (value === "") {
  //     const updatedProducts = [...filteredProducts];
  //     updatedProducts[productIndex].variants[variantIndex].transferStock = "";
  //     setFilteredProducts(updatedProducts);
  //     return;
  //   }
  
  //   const numericValue = Number(value);
  
  //   if (numericValue < 0) {
  //     showToast("Negative values are not allowed!", "error");
  
  //     const updatedProducts = [...filteredProducts];
  //     updatedProducts[productIndex].variants[variantIndex].transferStock = "";
  //     setFilteredProducts(updatedProducts);
  
  //     return;
  //   }
  
 
  //   const updatedProducts = [...filteredProducts];
  //   updatedProducts[productIndex].variants[variantIndex].transferStock = numericValue;
  //   setFilteredProducts(updatedProducts);
  // };
  
  


  const handletransferStockChange = (productIndex, variantIndex, value) => {
    let updatedProducts = [...filteredProducts];
    let isPreviewMode = showPreview;  // agar preview open hai
    let productsArray = isPreviewMode ? [...previewData.selectedProducts] : [...filteredProducts];
  
    const productId = productsArray[productIndex].id;
    const previousValue = Number(productsArray[productIndex].variants[variantIndex].transferStock) || 0;
    const numericValue = value === "" ? "" : Number(value);
  
    if (!selectedProducts.includes(productId)) return;
  
    // Input blank case
    if (value === "") {
      productsArray[productIndex].variants[variantIndex].transferStock = "";
  
      if (isPreviewMode) {
        setPreviewData((prev) => ({
          ...prev,
          selectedProducts: productsArray,
        }));
      } else {
        setFilteredProducts(productsArray);
      }
  
      setTotalQuantities((prev) => ({
        ...prev,
        [productId]: (Number(prev[productId]) || 0) - previousValue,
      }));
  
      setReceivedStockQty((prev) => ({
        ...prev,
        [productId]: "",
      }));
  
      return;
    }
  
    // Negative value case
    if (numericValue < 0) {
      showToast("Negative values are not allowed!", "error");
  
      productsArray[productIndex].variants[variantIndex].receivedStock = "";
  
      if (isPreviewMode) {
        setPreviewData((prev) => ({
          ...prev,
          selectedProducts: productsArray,
        }));
      } else {
        setFilteredProducts(productsArray);
      }
  
      setTotalQuantities((prev) => ({
        ...prev,
        [productId]: (Number(prev[productId]) || 0) - previousValue,
      }));
  
      setReceivedStockQty((prev) => ({
        ...prev,
        [productId]: "",
      }));
  
      return;
    }
  
    // Normal positive input
    productsArray[productIndex].variants[variantIndex].transferStock = numericValue;
  
    if (isPreviewMode) {
      setPreviewData((prev) => ({
        ...prev,
        selectedProducts: productsArray,
      }));
    } else {
      setFilteredProducts(productsArray);
    }
  
    setTotalQuantities((prev) => ({
      ...prev,
      [productId]: (Number(prev[productId]) || 0) - previousValue + numericValue,
    }));
  
    setReceivedStockQty((prev) => ({
      ...prev,
      [productId]: numericValue,
    }));
  };
  
  
  


  const handleTrasferTypeChange = async (e) => {
    const selectedId = e.target.value;
    setReceiveType(selectedId);

    const selectedOption = transferTypes.find(
        (option) => option.id.toString() === selectedId
    );

    console.log("Selected Option:", selectedOption); 
    console.log("Selected Type:", selectedOption?.type); 

    setSelectedTypeName(selectedOption ? selectedOption.type : "");

    // Reset dependent fields
    setInvoiceNo("");
    setShop("");
    setPartyMaster("");
    setTransactionNo(""); 

  
    let apiType = selectedOption?.type1;

    console.log("Final API Type:", apiType); 
    try {
        const response = await apiClient.post(
            "/Liquor/GetTransactionNo",
            { type: apiType , companyId:companyId , typeId: "2" }
        );

        console.log("API Response:", response.data);

        if (response.data?.code === 200 && response.data?.data) {
            setTransactionNo(response.data.data); 
            showToast(`Transaction No. received!`,"success");
        } else {
            showToast("Invalid response from API!","error");
        }
    } catch (err) {
        console.error("API Error:", err);
        showToast("Failed to fetch transaction number!","error");
    }
};




  
  


const handleSubmit = async (event) => {
  event.preventDefault();

  try {
    // Step 1: General Validations
    if (!receiveType) {
      showToast("Please select a Transfer Type.", "error");
      return;
    }

    if (selectedTypeName === "RSBCL" && (!invoiceNo || !remark)) {
      showToast("Invoice No. and Remark are required for RSBCL.", "error");
      return;
    }

    if (selectedTypeName === "SHOP" && !shop) {
      showToast("Please select a Shop.", "error");
      return;
    }

    if (selectedTypeName !== "RSBCL" && selectedTypeName !== "SHOP" && !partyMaster) {
      showToast("Please select a Party Master.", "error");
      return;
    }

    // Step 2: Ensure at least one product is selected
    if (selectedProducts.length === 0) {
      showToast("Please select at least one product!", "error");
      return;
    }

    // ✅ Step 3: Sync totalQuantities with product variants
    const updatedProducts = filteredProducts.map((product) => {
      if (selectedProducts.includes(product.id)) {
        const updatedVariants = product.variants.map((variant) => ({
          ...variant,
          transferStock: Number(totalQuantities?.[product.id] || 0)
        }));
        return { ...product, variants: updatedVariants };
      }
      return product;
    });

    // Step 4: Ensure each selected product has at least one variant with transfer stock > 0
    for (const product of updatedProducts) {
      if (selectedProducts.includes(product.id)) {
        let hasValidStock = product.variants.some(
          (variant) => Number(variant.transferStock || 0) > 0
        );

        if (!hasValidStock) {
          showToast(`Please enter Transfer stock for ${product.name}!`, "error");
          return;
        }
      }
    }

    // Step 5: Prepare data for API
    const selectedData = updatedProducts
      .filter((product) => selectedProducts.includes(product.id))
      .map((product) => ({
        ProductId: product.id,
        TransferQty: Number(transferStocks?.[product.id] || 0), // Use transferStocks for TransferQty
 
       
        
        transferHeadQty: Number(totalQuantities?.[product.id] || 0),
        boxQty: Number(boxInputs?.[product.id] || 0)
      }));

    const finalInvoiceNo = invoiceNo?.trim() || "0";
    const finalPartyMaster = partyMaster || "0";
    const finalShop = shop || "0";

    const payload = {
      transferHeadId: receiveType,
      transferPartyId: finalPartyMaster,
      transferShopId: finalShop,
      shopId: shopId,
      StockDate: date || new Date().toISOString().split("T")[0],
      invoiceNo: finalInvoiceNo,
      Remark: remark,
      transactionNo: "0",
      transactionNumber: transactionNo,
      transferQtyDetails: selectedData
    };

    console.log("Data being sent to API:", JSON.stringify(payload, null, 2));

    setLoading(true);

    const response = await apiClient.post(
      "/Liquor/SaveBulkProductTransferDetails",
      payload
    );

    console.log("API Response:", response.data);

    if (response.status === 200) {
      if (response.data && response.data.data === "Negative stock detected after transaction.") {
        showToast("Negative stock detected!", "error");
      } else {
        showToast("Stock report submitted successfully!", "success");
        fetchStock();
      }
    } else {
      showToast(`Error submitting stock report: ${response.statusText}`, "error");
    }

  } catch (error) {
    console.error("Error submitting data:", error);
    showToast(error.response?.data?.message || "Failed to submit data!", "error");
  } finally {
    setLoading(false);
  }
};



const handlePreview = () => {
  if (filteredProducts.length === 0) {
    showToast("No product data available for preview!", "error");
    return;
  }

  const editedProducts = filteredProducts
    .filter((product) => selectedProducts.includes(product.id)) // only selected products
    .map((product) => ({
      ...product,
      boxCount: boxInputs[product.id] || "", // attach boxCount from input
      variants: product.variants.map((variant) => ({
        ...variant,
        totalQuantity: calculateTotalQuantity(product.id, variant), // optional helper if needed
      })),
    }))
    .filter((product) => {
      const boxCountValid = parseFloat(product.boxCount) > 0;
      const hasTransferStock = product.variants.some(
        (variant) => parseFloat(variant.transferStock) > 0
      );
      return boxCountValid || hasTransferStock;
    });

  if (editedProducts.length === 0) {
    showToast("Please enter box count or transfer stock to preview!", "error");
  } else {
    setPreviewData({ selectedProducts: editedProducts });
    setShowPreview(true);
  }
};


const calculateTotalQuantity = (productId, variant) => {
  const boxQty = boxQuantities[productId] || 0;
  const transferQty = variant.transferStock || 0;
  return boxQty + transferQty;
};
  
  
   
  const handleBoxChange = async (productId, value) => {
    setBoxInputs(prev => ({ ...prev, [productId]: value }));
  
    const parsedValue = parseInt(value, 10);
  
    if (!isNaN(parsedValue) && parsedValue >= 0) {
      try {
        const response = await apiClient.post(
          '/Liquor/GetProductQty',
          { productId, boxCount: parsedValue }
        );
  
        console.log("transferbox:",response)
        const quantityFromBox = response.data?.data?.quantity || 0;
  
        // ✅ Save boxQuantity separately
        setBoxQuantities(prev => ({
          ...prev,
          [productId]: quantityFromBox
        }));
  
        // ✅ Calculate transferStockTotal
        const product = filteredProducts.find(p => p.id === productId);
        let transferStockTotal = 0;
        if (product) {
          transferStockTotal = product.variants.reduce((sum, variant) => sum + (Number(variant.transferStock) || 0), 0);
        }
  
        // ✅ Final total = box + transfer
        const finalTotalQuantity = quantityFromBox + transferStockTotal;
  
        setTotalQuantities(prev => ({
          ...prev,
          [productId]: finalTotalQuantity
        }));
  
      } catch (error) {
        console.error("Error fetching boxwise quantity:", error);
        showToast("Failed to fetch quantity for the entered box count.", "error");
      }
    } else if (value === "") {
      setBoxQuantities(prev => ({
        ...prev,
        [productId]: 0
      }));
      setTotalQuantities(prev => ({
        ...prev,
        [productId]: 0
      }));
    } else {
      showToast("Please enter a valid box quantity.", "error");
    }
  };
  
  




  
  
  const handleTotalQuantityChange = (productId, value) => {
    // If value is empty, reset the total quantity and clear the transfer stock
    if (value === "") {
      setTotalQuantities(prev => ({
        ...prev,
        [productId]: boxQuantities[productId] || 0
      }));
  
      // Update filtered products and preview data (if preview is open)
      const updatedProducts = filteredProducts.map(product => {
        if (product.id === productId) {
          return {
            ...product,
            variants: product.variants.map(variant => ({
              ...variant,
              transferStock: ""  // Reset transfer stock when input is blank
            }))
          };
        }
        return product;
      });
  
      // If preview is open, also update the preview data
      if (showPreview) {
        const updatedPreviewData = previewData.selectedProducts.map(product => {
          if (product.id === productId) {
            return {
              ...product,
              variants: product.variants.map(variant => ({
                ...variant,
                transferStock: ""  // Reset transfer stock in preview
              }))
            };
          }
          return product;
        });
  
        setPreviewData(prev => ({
          ...prev,
          selectedProducts: updatedPreviewData
        }));
      }
  
      setFilteredProducts(updatedProducts);
      
      // Clear the transfer stock state for this product
      setTransferStocks(prev => ({
        ...prev,
        [productId]: "" // Reset transfer stock value
      }));
  
      return;
    }
  
    // Convert value to numeric
    const numericValue = Number(value);
  
    // Check for invalid input
    if (isNaN(numericValue) || numericValue < 0) {
      showToast("Invalid quantity entered", "error");
      return;
    }
  
    // Update the filtered products with the new transfer stock
    const updatedProducts = filteredProducts.map(product => {
      if (product.id === productId) {
        return {
          ...product,
          variants: product.variants.map(variant => ({
            ...variant,
            transferStock: numericValue
          }))
        };
      }
      return product;
    });
  
    // If preview is open, also update the preview data with the new transfer stock
    if (showPreview) {
      const updatedPreviewData = previewData.selectedProducts.map(product => {
        if (product.id === productId) {
          return {
            ...product,
            variants: product.variants.map(variant => ({
              ...variant,
              transferStock: numericValue
            }))
          };
        }
        return product;
      });
  
      setPreviewData(prev => ({
        ...prev,
        selectedProducts: updatedPreviewData
      }));
    }
  
    setFilteredProducts(updatedProducts);
  
    // Calculate the total quantity (box quantity + transfer stock)
    const boxQuantity = boxQuantities[productId] || 0;
    const finalTotal = boxQuantity + numericValue;
  
    // Update total quantities state
    setTotalQuantities(prev => ({
      ...prev,
      [productId]: finalTotal
    }));
  
    // Store the transfer stock value in the state
    setTransferStocks(prev => ({
      ...prev,
      [productId]: numericValue // Store transfer stock for this product
    }));
  };
  
    
  
  
  
  
return (
     <div className="app-main flex-column flex-row-fluid" id="kt_app_main">
      {/* Content wrapper */}
      <div className="d-flex flex-column flex-column-fluid">
          {/* Toolbar */}
          <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
              {/* Toolbar container */}
              <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                  {/* Page title */}
                  <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                      {/* Title */}
                      <h1 className="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0">
                      Box Add Transfer Stock
                      </h1>
                      <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                          <li className="breadcrumb-item text-muted">
                              <a href="index.html" className="text-muted text-hover-primary">Home</a>
                          </li>
                          <li className="breadcrumb-item">
                              <span className="bullet bg-gray-500 w-5px h-2px"></span>
                          </li>
                          <li className="breadcrumb-item text-muted">Dashboards</li>
                      </ul>
                  </div>
              </div>
          </div>
    
          <div id="kt_app_content" className="app-content flex-column-fluid">
              <div id="kt_app_content_container" className="app-container container-fluid">
                  <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
                      <div className="col-xl-12">
                          <div className="card card-flush h-md-100">
                              <ToastContainer />
                            
                              <div className="card-body pt-6">
                                  <div className="table-responsive">
                                      <div className="panel-body">
                                          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                              <form className="form-inline">
                                                  <div className="form-group">
                                                      <p className="form-control-static">Search Products:</p>
                                                  </div>
                                                  <div className="form-group d-flex justify-content-between gap-5">
                                                      <label htmlFor="inputsearch" className="sr-only active">Search Products</label>
                                                      <input className="form-control" id="inputsearch" placeholder="Search Products"      value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)} type="text" autoComplete="off" />
                                                     
                                                      <input
    className="form-control "
    id="inputsearch"
    placeholder="Search Products"
    type="date"
    value={date} // Always in correct format
    max={new Date().toISOString().split("T")[0]} // Restrict future dates
    onChange={(e) => setDate(e.target.value)} // Update state
    autoComplete="off"
  />
                                                  </div>
 
                                              </form>



                                              <div className="form-group">
  <label htmlFor="transferTypes">Transfer Type</label>
  <select
    className="form-control"
    id="transferTypes"
    value={receiveType}
    onChange={handleTrasferTypeChange}
  >
    <option value="">Select Transfer Type</option>
    {transferTypes.map((option) => (
      <option key={option.id} value={option.id}>
        {option.label}
      </option>
    ))}
  </select>
</div>

                
{selectedTypeName === "RSBCL" && (
      <>
  <div className="form-group">
    <label htmlFor="invoiceNo">Invoice No.</label>
    <input
      type="text"
      className="form-control"
      id="invoiceNo"
      placeholder="Enter Invoice No."
      value={invoiceNo}
      onChange={(e) => setInvoiceNo(e.target.value)}
    />
  </div>
   <div className="form-group">
   <label htmlFor="remark">Remark</label>
   <input
     type="text"
     className="form-control"
     id="remark"
     placeholder="Enter Remark"
     value={remark}
     onChange={(e) => setRemark(e.target.value)}
   />
 </div>
 </>
)}


{selectedTypeName === "SHOP" && (
  <div className="form-group">
    <label htmlFor="shopDropdown">Shop</label>
    <select
      className="form-control"
      id="shopDropdown"
      value={shop}
      onChange={(e) => setShop(e.target.value)}
    >
      <option value="">Select Shop</option>
      {shopOptions.map((option) => (
        <option key={option.id} value={option.id}>{option.label}</option>
      ))}
    </select>
  </div>
)}

{/* Party Master (Default case) */}
{selectedTypeName !== "RSBCL" && selectedTypeName !== "SHOP" && (
  <div className="form-group">
    <label htmlFor="partyMaster">Party Master</label>
    <select
      className="form-control"
      id="partyMaster"
      value={partyMaster}
      onChange={(e) => setPartyMaster(e.target.value)}
    >
      <option value="">Select Party Master</option>
      {partyMasters.map((party) => (
        <option key={party.id} value={party.id}>
          {party.label}
        </option>
      ))}
    </select>
  </div>
)}


{/* <div className="form-group col-md-2">
  <label>Date:</label>
  <input
    type="date"
    className="form-control"
    value={date} // Always in correct format
    max={new Date().toISOString().split("T")[0]} // Restrict future dates
    onChange={(e) => setDate(e.target.value)} // Update state
  />
</div> */}


  <div className="panel-heading">
  
    {/* Transaction Number (Right Upper Corner) */}
    {transactionNo && (
      <span
        style={{
          position: "absolute",
          right: "45px",
          top: "60px", 
          fontWeight: "bold",
          color: "green",
          fontSize: "20px",
        }}
      >
        Transaction No: {transactionNo}
      </span>
    )}
  </div>



















                                          </div>
                                          <div className="clearfix"></div>
                                          <br />
                                          {apiConditionMet === null ? (
      <div className="loader-container">
               <FaSpinner className="spinner-icon" />
             </div>
    ) : apiConditionMet ? (
                                          <div className="table-responsive h-400px">
                 <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Select</th>
                      <th>Product Name</th>
                      <th>Volume</th>
                      <th>Rate</th>
                      <th>Opening Stock</th>
                      <th>Received Stock</th>
                      <th>Transfer Stock</th>
                      <th>Box</th> {/* New Column */}
                      <th>Total Quantity</th> {/* New Column */}
                      {/* <th>Total Stock</th> */}
                    
                    </tr>
                  </thead>
                  <tbody>
                    {filteredProducts.length > 0 ? (
                      filteredProducts.map((product, index) =>
                        product.variants.map((variant, vIndex) => {
                          const totalStock = variant.openingStock + (parseFloat(variant.receivedStock) || 0);
                          return (
                            <tr key={`${index}-${vIndex}`}>
                              {/* Checkbox */}
                              <td>
  <label className="checkbox-container">
    <input
      type="checkbox"
      checked={selectedProducts.includes(product.id)}
      onChange={() => handleCheckboxChange(product.id)}
    />
   
  </label>
</td>

                              <td>{product.name}</td>
                              <td>{variant.volume}</td>
                              <td className="numeric-input">{variant.rate}</td>
                              <td className="numeric-input">{variant.openingStock}</td>
                              <td className="numeric-input">{variant.receivedStock}</td>

                              <td className="numeric-input">
  <input
    type="text"
    value={variant.transferStock || ""}
    onChange={(e) =>
      handleTotalQuantityChange(product.id, e.target.value)
    }
    className="form-control"
    min="0"
    placeholder="Enter qty"
  />
</td>
<td className="numeric-input">
  <input
    type="text"
    min="0"
    value={boxInputs[product.id] || ""}
    onChange={(e) => handleBoxChange(product.id, e.target.value)}
    className="form-control"
    disabled={!selectedProducts.includes(product.id)}
  />
</td>

<td className="numeric-input">
<td>{totalQuantities[product.id] || "-"}</td>
</td>


                              {/* <td className="numeric-input">{totalStock}</td> */}
                              
                            </tr>
                          );
                        })
                      )
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center">No Products Found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
    
    
    
    
    
    
                                       
    
     

    
                                          </div>
                                            ) : (
                                              <p>Already Submitted Data</p> 
                                            )}



<div class="text-right align-items-right d-flex justify-content-end">
      <button type="submit" data-bs-toggle="modal" data-bs-target="#model3" className="btn btn-info mt-3 m-2"  onClick={handlePreview}>Preview</button>
       <button type="submit" className="btn btn-info mt-3 m-2"    onClick={handleSubmit}disabled={loading}   >{loading ? "Submitting..." : "Submit Report"}</button>
       </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    
      {/* Footer */}
      <div id="kt_app_footer" className="app-footer">
          <div className="app-container container-fluid d-flex flex-column flex-md-row flex-center flex-md-stack py-3">
              <div className="text-gray-900 order-2 order-md-1">
                  <span className="text-muted fw-semibold me-1">2025&copy;</span>
                  <a href="#" target="_blank" className="text-gray-800 text-hover-primary">WineShop</a>
              </div>
          </div>
      </div>
 
    
    
    
    
    
    
    
    {/* For transfer modal */}
    
    
  
    
    
    
    
    
        {/* Preview modal */}
    
        <div
    className="modal fade"
    id="model3"
    tabIndex={-1}
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    >
    <div className="modal-dialog modal-lg">
    <div className="modal-content">
    <div className="modal-header">
    <h1 className="modal-title fs-5" id="exampleModalLabel">
    Preview Details
    </h1>
    <button
    type="button"
    className="btn-close"
    data-bs-dismiss="modal"
    aria-label="Close"
    />
    </div>
    
    <div className="modal-body">
    <div className="previewdata">
    <table className="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Product Name</th>
              <th>Volume</th>
              <th>Rate</th>
                 {/* <th>Opening Stock</th>
              <th>Received Stock</th>  */}
              <th>Transfer Stock</th> 
              <th>Box</th> {/* 👈 New */}
              <th>Total Quantity</th> {/* 👈 New */}
            </tr>
          </thead>
          <tbody>
            {previewData?.selectedProducts
              ?.filter((product) => 
                product.variants.some((variant) => variant.transferStock !== undefined)
              ) // ✅ Sirf wahi products dikhayein jinme transferStock once set ho chuka hai
              .map((product, index) =>
                product.variants
                  .filter((variant) => variant.transferStock !== undefined)
                  .map((variant, vIndex) => (
                    <tr key={`${index}-${vIndex}`}>
                      <td>{product.name}</td>
                      <td>{variant.volume}</td>
                      <td>{variant.rate}</td>
                        {/* <td className="numeric-input">{variant.openingStock}</td>
                      <td>{variant.receivedStock}</td> */}
                      {/* ✅ Transfer Stock Input Field */}
                      <td className="numeric-input">
  <input
    type="text"
    value={variant.transferStock === "" ? "" : variant.transferStock}
    onChange={(e) =>
      handleTotalQuantityChange(product.id, e.target.value)
    }
    className="form-control"
    min="0"
    placeholder="Enter qty"
  />
</td>
<td className="numeric-input">
                    <input
                      type="text"
                      min="0"
                      value={boxInputs[product.id] || ""}
                      onChange={(e) => handleBoxChange(product.id, e.target.value)}
                      className="form-control"
                      disabled={!selectedProducts.includes(product.id)}
                    />
                  </td>

        {/* ✅ Show total quantity */}
        <td>{totalQuantities[product.id] || "-"}</td>
                    </tr>
                  ))
              )}
          </tbody>
        </table>
          </div>
    </div>
    
    <div className="modal-footer">
    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
    Close
    </button>
    </div>
    </div>
    </div>
    </div>
    
    </div>
);
};

export default Boxentrydesitransfer;